module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activeTab === 'Contact'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Contact'
      },
      "aria-expanded": "false"
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'FAQ'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'FAQ'
      },
      "aria-expanded": "false"
    }
  }, [_vm._v("Frequently asked questions")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'Help and Tutorials'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Help and Tutorials'
      },
      "aria-expanded": "false"
    }
  }, [_vm._v("Video tutorials")])], 1)])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject font-dark sbold uppercase"
  }, [_vm._v("Support")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c843efa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Support.vue
// module id = 1549
// module chunks = 1